"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var forms_1 = require("@angular/forms");
var skynet_store_currencies_impl_1 = require("@synisys/skynet-store-currencies-impl");
var sis_tabular_report_view_component_1 = require("./sis-tabular-report-view.component");
var sis_tabular_report_invalid_state_module_1 = require("../invalid-state/sis-tabular-report-invalid-state.module");
var common_1 = require("@angular/common");
var reporting_pipes_module_1 = require("../pipes/reporting-pipes.module");
var report_export_menu_component_1 = require("../report-export-menu/report-export-menu.component");
var idm_ng_controls_1 = require("@synisys/idm-ng-controls");
var idm_report_export_service_client_js_1 = require("@synisys/idm-report-export-service-client-js");
var idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
var sis_material_module_1 = require("../modules/sis-material-module");
var report_export_dialog_1 = require("../report-export-menu/report-export-dialog/report-export.dialog");
var sis_tabular_report_view_big_data_warning_popup_module_1 = require("../report-view-warning-popup/sis-tabular-report-view-big-data-warning-popup.module");
var report_publish_dialog_component_1 = require("../report-export-menu/report-publish-dialog/report-publish-dialog.component");
var publish_service_1 = require("../report-export-menu/service/publish.service");
var http_publish_service_1 = require("../report-export-menu/service/http-publish.service");
require("@synisys/synergy-design-system");
var report_export_delimiter_dialog_1 = require("../report-export-menu/report-export-delimiter-dialog/report-export-delimiter.dialog");
var SisTabularReportViewModule = /** @class */ (function () {
    function SisTabularReportViewModule() {
    }
    SisTabularReportViewModule = __decorate([
        core_1.NgModule({
            declarations: [
                sis_tabular_report_view_component_1.SisTabularReportViewComponent,
                report_export_menu_component_1.ReportExportMenuComponent,
                report_export_dialog_1.ReportExportDialogComponent,
                report_publish_dialog_component_1.ReportPublishDialogComponent,
                report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
            ],
            imports: [
                common_1.CommonModule,
                forms_1.FormsModule,
                reporting_pipes_module_1.ReportingPipesModule,
                idm_ng_controls_1.ControlsModule,
                sis_tabular_report_invalid_state_module_1.SisTabularReportInvalidStateModule,
                sis_material_module_1.SisMaterialModule,
                skynet_store_currencies_impl_1.CurrencyStoreModule,
                sis_tabular_report_view_big_data_warning_popup_module_1.ReportViewBigDataWarningPopupModule
            ],
            providers: [
                { provide: idm_report_export_service_client_js_1.ReportExportService, useClass: idm_report_export_service_client_js_1.HttpReportExportService },
                { provide: idm_dataset_service_client_js_1.PathFormsService, useClass: idm_dataset_service_client_js_1.HttpPathFormsService },
                { provide: publish_service_1.PublishService, useClass: http_publish_service_1.HttpPublishService }
            ],
            exports: [
                sis_tabular_report_view_component_1.SisTabularReportViewComponent,
                report_export_menu_component_1.ReportExportMenuComponent,
                report_export_dialog_1.ReportExportDialogComponent,
                report_publish_dialog_component_1.ReportPublishDialogComponent,
                report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
            ],
            entryComponents: [
                report_export_dialog_1.ReportExportDialogComponent,
                report_publish_dialog_component_1.ReportPublishDialogComponent,
                report_export_delimiter_dialog_1.ReportExportDelimiterDialogComponent
            ],
            schemas: [core_1.CUSTOM_ELEMENTS_SCHEMA],
        })
    ], SisTabularReportViewModule);
    return SisTabularReportViewModule;
}());
exports.SisTabularReportViewModule = SisTabularReportViewModule;
//# sourceMappingURL=sis-tabular-report-view.module.js.map